var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdereLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 628.2 139.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #36a9e1;\n      }\n\n      .st2 {\n        fill: #95c11f;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n\n      .st4 {\n        fill: #e6332a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -38,
    y: -82,
    width: 335.4,
    height: 335.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M126.5,131.8h-3c-2.9,0-5.6-1.4-7.4-3.7l-48.9-63.7c-1.6-2.2-5.2-2.3-7.1.2l-41.4,54.9c-1.2,1.6-.2,2.5.9,2.5h20.8c2.6,0,4.9,2,5,4.6.2,2.8-2.1,5.2-4.9,5.2h-24.5c-3.6,0-6.8-2-8.4-5.3-1.7-3.5-1.3-7.6,1-10.7l47.9-62.2c1.8-2.3,4.5-3.7,7.4-3.7h0c2.9,0,5.6,1.4,7.4,3.7l51,66.8c.8,1.1,2.1,1.7,3.5,1.7h.7c2.8,0,5.1,2.4,4.9,5.2-.2,2.6-2.4,4.6-5,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.3,131.8h-27c-2.9,0-5.6-1.4-7.4-3.7l-49.1-64.2c-1.5-2-4.5-2-6,0l-44.5,57.8c-.3.4-.7,1-1.1,1.5-2.4,3.4-6.1,8.6-12.9,8.6h-25.3c-2.6,0-4.9-2-5-4.6-.2-2.8,2.1-5.2,4.9-5.2h24.5c1.7-.1,4-1.8,6-4.5.4-.6.9-1.2,1.3-1.8l47.9-62.2c1.8-2.3,4.5-3.7,7.4-3.7h0c2.9,0,5.6,1.4,7.4,3.7l50.8,66.4c1,1.3,2.5,2,4.1,2h24.3c2.8,0,5.1,2.4,4.9,5.2-.2,2.6-2.4,4.6-5,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.7,131.8h-24.3c-2.6,0-4.9-2-5-4.6-.2-2.8,2.1-5.2,4.9-5.2h19.4c1,0,2.5-1.8.9-4l-40.6-53.9c-1.6-2.1-4.7-2.1-6.3,0l-49,64c-1.8,2.4-4.5,3.7-7.4,3.7h-2c-2.6,0-4.9-2-5-4.6-.2-2.8,2.1-5.2,4.9-5.2s2.4-.6,3.1-1.5l51.2-66.9c1.8-2.4,4.5-3.7,7.4-3.7,2.9,0,5.6,1.3,7.4,3.7l47.9,62.2c2.4,3.1,2.8,7.2,1,10.7-1.6,3.3-4.8,5.3-8.4,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.5,29.7c0,9-7.3,16.2-16.2,16.2s-16.2-7.3-16.2-16.2,7.3-16.2,16.2-16.2,16.2,7.3,16.2,16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.8,29.7c0,9-7.3,16.2-16.2,16.2s-16.2-7.3-16.2-16.2,7.3-16.2,16.2-16.2,16.2,7.3,16.2,16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.1,29.7c0,9-7.3,16.2-16.2,16.2s-16.2-7.3-16.2-16.2,7.3-16.2,16.2-16.2,16.2,7.3,16.2,16.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.4,112.8l-6.2-20.2h-31.1l-6.2,20.2h-19.5l30.1-85.3h22.1l30.2,85.3h-19.5ZM327.9,77.5c-5.7-18.3-8.9-28.7-9.6-31.1-.7-2.4-1.2-4.3-1.5-5.7-1.3,5-5,17.2-11,36.8h22.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M431.2,69.5c0,14-4,24.7-12,32.1-8,7.4-19.5,11.2-34.6,11.2h-24.1V27.8h26.8c13.9,0,24.7,3.7,32.4,11,7.7,7.3,11.5,17.6,11.5,30.7ZM412.4,70c0-18.2-8.1-27.4-24.3-27.4h-9.6v55.3h7.8c17.4,0,26.1-9.3,26.1-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M489.8,112.8h-49.1V27.8h49.1v14.8h-31v18.7h28.9v14.8h-28.9v21.9h31v14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M517.6,80.2v32.6h-18.1V27.8h24.8c11.6,0,20.1,2.1,25.7,6.3,5.6,4.2,8.3,10.6,8.3,19.1s-1.4,9.4-4.1,13.3c-2.8,3.9-6.7,6.9-11.7,9.2,12.8,19.1,21.2,31.4,25.1,37h-20.1l-20.3-32.6h-9.6ZM517.6,65.6h5.8c5.7,0,9.9-.9,12.7-2.8,2.7-1.9,4.1-4.9,4.1-9s-1.4-6.9-4.2-8.6c-2.8-1.7-7.1-2.6-12.9-2.6h-5.5v23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M619.3,112.8h-49.1V27.8h49.1v14.8h-31v18.7h28.9v14.8h-28.9v21.9h31v14.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdereLogo);
export default __webpack_public_path__ + "static/media/adere_logo.8b7b221f402202f515bbeb6609dfc117.svg";
export { ForwardRef as ReactComponent };